import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { customStyles } from "../../assets/table-style";
import "@fortawesome/fontawesome-free/css/all.min.css";
import BASE_URL from "../../assets/global/url";
import { Link, useNavigate } from "react-router-dom";
import { ThreeDot } from "react-loading-indicators";
import NoAccess from "../../assets/img/NoAccess.png";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { PaginationControls } from "../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../hooks/customHook/paginationHook/useServerPagination";
import swal from "sweetalert";
import DateRangePicker from "../../components/DateRangePicker";
import { getMonthBoundaries, initializeCutoff } from "../../utils/newdate";
import FilterStore from "../../hooks/customHook/FilterStore";
import useDecodeToken from "../../hooks/customHook/useDecodeToken";
import { useServerSort } from "../../hooks/customHook/sortingHook/useTableSort";
import { Tabs, Tab } from "react-bootstrap";

const StockTransfer = ({ authrztn }) => {
  const navigate = useNavigate();
  const userLoggedID = useDecodeToken();
  const [searchText, setSearchText] = useState(() =>
    FilterStore.STgetSearch(`Stock_transfer`),
  );

  useEffect(() => {
    FilterStore.NPsaveSearch(searchText, `Stock_transfer`);
  }, [searchText]);

  const [filterColumn, setFilterColumn] = useState(() =>
    FilterStore.getFilterColumn(),
  );

  // "Pending" lists all pending transfers (no date filter);
  // "Approved" is filtered by the date range
  const [activeTab, setActiveTab] = useState(() => FilterStore.STgetTab());
  const [isLoading, setIsLoading] = useState(true);
  const [stockTransferList, setStockTransferList] = useState([]);
  const [dateFilter, setDateFilter] = useState({
    dateFrom: "",
    dateTo: "",
  });
  const [selectedCutOff, setSelectedCutOff] = useState(""); // state for input select
  const [cutOffs, setCutOffs] = useState([]); // state for all cut off
  const [cutOffDate, setCutOffDate] = useState(""); // state for input date
  const isInitialMount = useRef(true);
  const pageRestored = useRef(false);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    pagination.setCurrentPage(1);
    fetchStockTransferList(selectedCutOff);
  }, [searchText]);

  useEffect(() => {
    FilterStore.saveFilterColumn(filterColumn);
    if (!isInitialMount.current) {
      pagination.setCurrentPage(1);
      fetchStockTransferList(selectedCutOff);
    }
  }, [filterColumn]);

  const handleCutoffChange = (value) => {
    let filteredCutoff;
    if (value === "All Cutoff" || !value) {
      const ascendingSortedCutoff = cutOffs.sort(
        (a, b) => new Date(b.from) - new Date(a.from),
      );
      filteredCutoff = {
        from: ascendingSortedCutoff[ascendingSortedCutoff.length - 1]?.from,
        to: ascendingSortedCutoff[0]?.to,
      };
    } else {
      [filteredCutoff] = cutOffs.filter((item) => {
        return item.id == value;
      });
    }
    return filteredCutoff;
  };

  // handle change select cutoff date
  const handleSelect = (e) => {
    const filteredCutoff = handleCutoffChange(e.target.value);

    pagination.setCurrentPage(1);

    setSelectedCutOff(filteredCutoff);
    fetchStockTransferList(filteredCutoff);
  };

  // set start and end date for input date
  const startAndEndDate = useCallback(() => {
    const filteredCutoff = handleCutoffChange(selectedCutOff?.id);

    setCutOffDate(filteredCutoff); // set state for input date
  }, [cutOffs, selectedCutOff]);

  useEffect(() => {
    startAndEndDate();
  }, [selectedCutOff]);

  const fetchCutoff = async () => {
    // try {
    //   const res = await axios.get(BASE_URL + "/outstanding/getCutoffs");
    //   let defaultCutOff = res.data[0];
    //   // get the latest date for default cut off
    //   for (let index = 1; index < res.data.length; index++) {
    //     if (res.data[index].to > defaultCutOff.to) {
    //       defaultCutOff = res.data[index];
    //     }
    //   }
    //   if (selectedCutOff) {
    //     const filteredCutoff = handleCutoffChange(selectedCutOff?.id);

    //     setSelectedCutOff(filteredCutoff); // set default cut off
    //     fetchStockTransferList(filteredCutoff);
    //   } else {
    //     setCutOffs(res.data);
    //     setSelectedCutOff(defaultCutOff); // set default cut off
    //     fetchStockTransferList(defaultCutOff);
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
    /// PARA ITO SA FILTER RETENTION
    //START

    const savedFilter = FilterStore.get();

    const initialCutoff =
      savedFilter ??
      (() => {
        const boundaries = getMonthBoundaries();
        return initializeCutoff(boundaries);
      })(); //END

    setSelectedCutOff(initialCutoff);
    setCutOffDate(initialCutoff);
    fetchStockTransferList(initialCutoff);
  };

  useEffect(() => {
    fetchCutoff();
  }, []);

  const handleDateChange = (e) => {
    setDateFilter((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const pagination = useServerPagination(
    BASE_URL + "/stock_transfer/getStockTransfer",
    FilterStore.STgetPerPage(),
  );

  // No initial sortBy: the backend default (newest first) has no visible column,
  // so every header starts neutral until the user picks one
  const sort = useServerSort(pagination);

  ///PARA ITO SA FILTER RETENTION NG PAGE
  //START
  // Save currentPage. Gate is closed until after mount restore so the hook's
  // internal reset-to-1 doesn't overwrite the saved page.
  useEffect(() => {
    if (!pageRestored.current) return;
    if (pagination.currentPage) {
      FilterStore.STsavePage(pagination.currentPage);
    }
  }, [pagination.currentPage]);

  useEffect(() => {
    if (pagination.itemsPerPage) {
      FilterStore.STsavePerPage(pagination.itemsPerPage);
    }
  }, [pagination.itemsPerPage]);

  // Restore last viewed page on mount. Deferred with setTimeout so it runs
  // after fetchCutoff → fetchStockTransferList → updateParams → reset-to-1
  // has settled, then opens the save gate for user navigation.
  useEffect(() => {
    const savedPage = FilterStore.STgetPage();
    if (savedPage > 1) {
      setTimeout(() => {
        pagination.setCurrentPage(savedPage);
        pageRestored.current = true;
      }, 0);
    } else {
      setTimeout(() => {
        pageRestored.current = true;
      }, 0);
    }
  }, []);
  //END

  const fetchStockTransferList = (cutOff, tab = activeTab) => {
    if (!cutOff) return;

    const isPendingTab = tab === "Pending";
    pagination.updateParams({
      startDate: isPendingTab ? undefined : cutOff?.from,
      endDate: isPendingTab ? undefined : cutOff?.to,
      status: tab,
      filterColumn,
      searchText,
    });
    setIsLoading(false);
    // axios
    //   .get(BASE_URL + "/stock_transfer/getStockTransfer", {
    //     params: {
    //       startDate: cutOff?.from,
    //       endDate: cutOff?.to,
    //       filterColumn,
    //       searchText,
    //     },
    //   })
    //   .then((res) => {
    //     setStockTransferList(res.data);
    //     setIsLoading(false);
    //   })
    //   .catch((err) => console.log(err));
  };

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     fetchStockTransferList();
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    setStockTransferList(pagination.data);
  }, [pagination.data]);

  useEffect(() => {
    fetchStockTransferList(selectedCutOff); // UPDATE FOR FILTER RETNETION
  }, [searchText]);

  const columns = [
    {
      name: "Transaction ID",
      // Old records have no client_transaction_id, so fall back to transaction_id
      selector: (row) => row.client_transaction_id || row.transaction_id,
      sortField: "client_transaction_id",
    },
    {
      name: "From",
      selector: (row) => row.warehouse_from.name,
      sortField: "warehouse_from",
    },
    {
      name: "To",
      selector: (row) => row.warehouse_to.name,
      sortField: "warehouse_to",
    },
    {
      name: "Date Transfered",
      selector: (row) => format(row.date_transfer, "MMM/dd/yyyy"),
      sortField: "date_transfer",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortField: "status",
      cell: (row) => {
        let color;
        switch (row.status) {
          case "Pending":
            color = "#FFA500";
            break;
          case "Approved":
            color = "#3B9F3F";
            break;
          case "Rejected":
            color = "#FF0000";
            break;
          default:
            color = "initial";
        }
        return (
          <div
            style={{
              padding: "5px 10px",
              borderRadius: "5px",
              color: color,
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            {row.status}
          </div>
        );
      },
    },
    {
      name: "Action",
      selector: (row) => (
        <i
          className="fas fa-trash text-center"
          style={{ cursor: "pointer", color: "red", fontSize: "1.5rem" }}
          onClick={() =>
            handleDeleteStockTransfer(
              row.id,
              row.warehouse_from_id,
              row.status,
              row.date_transfer,
            )
          }
        ></i>
      ),
    },
  ];

  console.log(stockTransferList);

  const handleDeleteStockTransfer = async (
    id,
    warehouse_id,
    status,
    date_transfer,
  ) => {
    try {
      swal({
        icon: "warning",
        title: "Confirm Deletion",
        text: "Are you sure you want to delete?",
        dangerMode: true,
        buttons: ["Cancel", "OK"],
      })
        .then(async (confirm) => {
          if (confirm) {
            const res = await axios.delete(
              `${BASE_URL}/stock_transfer/deleteStockTransfer/${id}`,
              {
                params: {
                  warehouse_id: warehouse_id,
                  status: status,
                  date_transfer: date_transfer,
                  userLoggedID,
                },
              },
            );

            if (res.status === 200) {
              swal({
                icon: "success",
                title: "Successfully Deleted",
                text: "Stock Transfer Successfully Deleted.",
              }).then(() => {
                // Re-fetch the current page with the current filters.
                // (cutOffs is no longer populated since filter retention,
                // so the old cutOffs lookup returned undefined and skipped the refetch)
                pagination.refreshData();
              });
              return;
            }
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            swal({
              icon: "error",
              // title: "Please contact your support",
              title: error.response.data.title,
              text: error.response.data.message,
            }); // test 1
          } else {
            swal({
              title: "Something went wrong",
              text: "Please contact your support immediately",
              icon: "error",
              timer: 2000,
            });
            console.error(error);
          }
        });
    } catch (error) {
      if (error.response.status === 401) {
        swal({
          icon: "error",
          // title: "Please contact your support",
          title: error.response.data.title,
          text: error.response.data.message,
        }); // test 1
      } else {
        swal({
          title: "Something went wrong",
          text: "Please contact your support immediately",
          icon: "error",
          timer: 2000,
        });
        console.error(error);
      }
    }
  };

  const handleDateRangeChange = (startDate, endDate) => {
    const cutoff = {
      id: "custom",
      from: startDate,
      to: endDate,
    };
    setSelectedCutOff(cutoff);
    setCutOffDate(cutoff);

    pagination.setCurrentPage(1);
    fetchStockTransferList(cutoff);
    FilterStore.save(startDate, endDate); //FILTER RETENTION
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    FilterStore.STsaveTab(tab);

    pagination.setCurrentPage(1);
    fetchStockTransferList(selectedCutOff, tab);
  };

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      {isLoading ? (
        <div className="loading-container">
          <ThreeDot
            variant="brick-stack"
            color="#6290FE"
            size="large"
            text="Loading Data..."
            textColor=""
          />
        </div>
      ) : authrztn.includes("StockTransfer-View") ? (
        <>
          <div className="w-100 p-2 d-flex flex-row justify-content-between">
            <div className="d-flex flex-column title-custom">
              <span className="fs-3">STOCK TRANSFERS</span>
              {/* <span>STOCK COUNTING</span> */}
            </div>
            {authrztn.includes("StockTransfer-Add") && (
              <div>
                <Link
                  to="/inventory/create-stock-transfer"
                  className="btn btn-primary d-flex flex-row align-items-center title-button"
                >
                  <i className="bx bx-plus fs-5"></i> Create
                </Link>
              </div>
            )}
          </div>
          <div className="container-fluid mt-4 p-0">
            <div className="row mx-auto">
              {/* <div className="col-sm mb-2">
                <span>From</span>
                <input
                  type="date"
                  name="dateFrom"
                  id="dateFrom"
                  value={dateFilter.dateFrom}
                  className="form-control"
                  onChange={handleDateChange}
                />
              </div>
              <div className="col-sm mb-2">
                <span>To</span>
                <input
                  type="date"
                  name="dateTo"
                  id="dateTo"
                  min={dateFilter.dateFrom}
                  value={dateFilter.dateTo}
                  className="form-control"
                  onChange={handleDateChange}
                />
              </div> */}
              <div className="col-sm">
                {activeTab === "Approved" && (
                  <DateRangePicker
                    startDate={
                      cutOffDate?.from ? new Date(cutOffDate.from) : null
                    }
                    endDate={cutOffDate?.to ? new Date(cutOffDate.to) : null}
                    onDateRangeChange={handleDateRangeChange}
                    label="Date Range"
                  />
                )}
                {/* <label htmlFor="cutoff">Cutoff</label>
                <select
                  value={selectedCutOff?.id}
                  onChange={handleSelect}
                  className="form-select"
                  id="cutoff"
                  aria-label="Default select example"
                  onMouseDown={(e) => {
                    if (cutOffs.length === 0) {
                      e.preventDefault();
                      swal({
                        icon: "warning",
                        title: "No Cutoff Found",
                        text: "No cutoff records found. Please create a cutoff first in Monthly Cutoff Module.",
                      });
                      return;
                    }
                  }}
                >
                  <option value="All Cutoff">All</option>
                  {cutOffs.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select> */}
              </div>
              {/* <div className="col-sm">
                <label htmlFor="cutoff-start-date">From</label>
                <input
                  type="date"
                  value={cutOffDate?.from || ""}
                  readOnly
                  name="cutoff-start-date"
                  id="cutoff-start-date"
                  className="form-control"
                />
                <DatePicker
                  selected={cutOffDate?.from}
                  dateFormat="MMM/dd/yyyy"
                  className="form-control"
                  readOnly
                />
              </div>
              <div className="col-sm">
                <label htmlFor="cutoff-end-date">To</label>
                <input
                  type="date"
                  value={cutOffDate?.to || ""}
                  readOnly
                  name="cutoff-end-date"
                  id="cutoff-end-date"
                  className="form-control"
                />
                <DatePicker
                  selected={cutOffDate?.to}
                  dateFormat="MMM/dd/yyyy"
                  className="form-control"
                  readOnly
                />
              </div> */}
              {/* <div className="col-sm d-none flex-row align-items-end mb-2 filter-btn-container w-100">
                <button className="btn w-100 d-none">Apply Filter</button>
                <button
                  className="btn btn-secondary w-100"
                  onClick={() => {
                    setDateFilter({
                      dateFrom: "",
                      dateTo: "",
                    });
                  }}
                >
                  Clear Filter
                </button>
              </div> */}
              {/* <div className="col-sm mb-2"></div> */}
              <div className="col-sm mb-2"></div>
            </div>
          </div>
          <div className="w-100 mt-3 mb-2 container-fluid">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-outline-secondary dropdown-toggle-split"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-sliders"></i>
              </button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "all" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("all")}
                  >
                    All
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "transaction_id" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("transaction_id")}
                  >
                    Transaction ID
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "product_code" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("product_code")}
                  >
                    Product Code
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "product_name" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("product_name")}
                  >
                    Product Name
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "from" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("from")}
                  >
                    From
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "to" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("to")}
                  >
                    To
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "date_transfer" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("date_transfer")}
                  >
                    Date Transfered
                  </button>
                </li>
                <li>
                  <button
                    className={`dropdown-item ${
                      filterColumn === "status" ? "active" : ""
                    }`}
                    onClick={() => setFilterColumn("status")}
                  >
                    Status
                  </button>
                </li>
              </ul>
            </div>
          </div>
          {/* data table */}
          <div className="w-100 mt-3 container-fluid">
            <Tabs
              activeKey={activeTab}
              onSelect={handleTabChange}
              transition={false}
              id="stock-transfer-tabs"
              className="mb-3"
            >
              <Tab
                eventKey="Pending"
                title={
                  <span>
                    Pending{" "}
                    {pagination.pendingCount > 0 && (
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "#000",
                          color: "#fff",
                          borderRadius: "999px",
                          fontSize: "0.7rem",
                          fontWeight: "bold",
                          minWidth: "1.4em",
                          height: "1.4em",
                          padding: "0 0.4em",
                          lineHeight: 1,
                          verticalAlign: "middle",
                          marginLeft: "4px",
                        }}
                      >
                        {pagination.pendingCount}
                      </span>
                    )}
                  </span>
                }
              />
              <Tab eventKey="Approved" title="Approved" />
            </Tabs>
            <DataTable
              onRowClicked={(row) => {
                navigate(`/inventory/view-stock-transfer/${row.id}`);
              }}
              columns={sort.sortColumns(columns)}
              customStyles={customStyles}
              data={stockTransferList}
              className="dataTable"
              {...sort.sortProps}
            />
            <PaginationControls {...pagination} />
          </div>
        </>
      ) : (
        <div className="no-access">
          <img src={NoAccess} alt="NoAccess" className="no-access-img" />
          <h3>You don't have access to this function.</h3>
        </div>
      )}
    </div>
  );
};

export default StockTransfer;
